/* =============================================================================
   Ella Custom JS - Sidebar Filter Accordions & Interactions
   ============================================================================= */

(function () {
    'use strict';

    function toggleSidebarBlock(block) {
        if (!block) return;
        var $block = window.jQuery ? window.jQuery(block) : null;
        var heading = block.querySelector('.sidebarBlock-heading');
        var content = block.querySelector('.sidebarBlock-contentWrapper') || block.querySelector('.sidebarBlock-content');

        if (!content) return;

        if ($block && typeof $block.find === 'function') {
            var $content = $block.find('.sidebarBlock-contentWrapper').length 
                ? $block.find('.sidebarBlock-contentWrapper') 
                : $block.find('.sidebarBlock-content');
            var $heading = $block.find('.sidebarBlock-heading');

            $heading.toggleClass('is-clicked');
            $content.stop(true, true).slideToggle(250);
        } else {
            var isClosed = content.style.display === 'none' || getComputedStyle(content).display === 'none';
            if (isClosed) {
                content.style.display = 'block';
                if (heading) heading.classList.add('is-clicked');
            } else {
                content.style.display = 'none';
                if (heading) heading.classList.remove('is-clicked');
            }
        }
    }

    document.addEventListener('click', function (e) {
        var headingTrigger = e.target.closest('.sidebarBlock-headingWrapper') || e.target.closest('.sidebarBlock-heading');
        if (!headingTrigger) return;
        if (e.target.closest('.custom-search-input') || e.target.tagName === 'INPUT' || e.target.tagName === 'A') return;

        var block = headingTrigger.closest('.sidebarBlock');
        if (!block) return;

        e.preventDefault();
        e.stopPropagation();
        toggleSidebarBlock(block);
    });

    /* =========================================================================
       Independent Sidebar Filters (By Pet, By Category, By Brand, By Weight)
       ========================================================================= */
    function initMikiFacetInteractions() {
        var urlParams = new URLSearchParams(window.location.search);
        var activeBy = urlParams.get('by') || sessionStorage.getItem('miki_filter_by');

        var blockMap = {
            'pet': '.sidebarBlock-filter-pet',
            'category': '.sidebarBlock-filter-category',
            'brand': '.sidebarBlock-filter-brand',
            'weight': '.sidebarBlock-filter-weight'
        };

        if (activeBy && blockMap[activeBy]) {
            // Remove active/checked state from any other block
            Object.keys(blockMap).forEach(function(key) {
                if (key !== activeBy) {
                    var otherBlock = document.querySelector(blockMap[key]);
                    if (otherBlock) {
                        otherBlock.querySelectorAll('.miki-facet-link.is-active').forEach(function(link) {
                            link.classList.remove('is-active');
                            var cb = link.querySelector('.miki-brand-checkbox');
                            if (cb) {
                                cb.classList.remove('checked');
                                cb.innerHTML = '';
                            }
                        });
                    }
                }
            });

            // Ensure the activeBy block reflects the active item
            var activeBlock = document.querySelector(blockMap[activeBy]);
            if (activeBlock) {
                var currentPath = window.location.pathname;
                activeBlock.querySelectorAll('.miki-facet-link').forEach(function(link) {
                    var targetUrl = link.getAttribute('data-target-url') || link.getAttribute('href');
                    if (targetUrl && (targetUrl === currentPath || targetUrl.indexOf(currentPath) !== -1 || currentPath.indexOf(targetUrl) !== -1)) {
                        link.classList.add('is-active');
                        var cb = link.querySelector('.miki-brand-checkbox');
                        if (cb) {
                            cb.classList.add('checked');
                            if (!cb.querySelector('svg')) {
                                cb.innerHTML = '<svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="#ffffff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 8.5l3.5 3.5 7.5-7.5"/></svg>';
                            }
                        }
                    }
                });
            }
        } else {
            // If neither is specifically in URL/sessionStorage, ensure Pet and Category don't both show checked
            var petActive = document.querySelector('.sidebarBlock-filter-pet .miki-facet-link.is-active');
            var catActive = document.querySelector('.sidebarBlock-filter-category .miki-facet-link.is-active');
            if (petActive && catActive) {
                petActive.classList.remove('is-active');
                var pCb = petActive.querySelector('.miki-brand-checkbox');
                if (pCb) {
                    pCb.classList.remove('checked');
                    pCb.innerHTML = '';
                }
            }
        }
    }

    // Handle clicks on facet links to store selection type and support toggle/deselect
    document.addEventListener('click', function(e) {
        var link = e.target.closest('.miki-facet-link');
        if (!link) return;

        var filterType = link.getAttribute('data-filter-type');
        if (link.classList.contains('is-active')) {
            // Deselecting: clear stored filter
            sessionStorage.removeItem('miki_filter_by');
        } else if (filterType) {
            // Selecting: remember filter type
            sessionStorage.setItem('miki_filter_by', filterType);
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMikiFacetInteractions);
    } else {
        initMikiFacetInteractions();
    }
    window.addEventListener('popstate', initMikiFacetInteractions);

    /* =========================================================================
       Miki Wishlist Manager & Toast Popup (Like Add To Cart Popup)
       ========================================================================= */
    var wishlistToastTimer = null;

    function getWishlistItems() {
        try {
            var raw = localStorage.getItem('wishlistItem');
            var parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
        } catch (e) {
            return [];
        }
    }

    function saveWishlistItems(items) {
        try {
            localStorage.setItem('wishlistItem', JSON.stringify(items));
        } catch (e) {}
    }

    function syncWishlistUI() {
        var items = getWishlistItems();
        var count = items.length;

        // Update all badge counts everywhere in header, navigation, and mobile bars
        document.querySelectorAll('[data-wishlist-count], .miki-wishlist-count, .wishlist-count-bubble').forEach(function(el) {
            el.textContent = count;
        });

        // Update all wishlist buttons on the page
        document.querySelectorAll('[data-wishlist], .miki-card-wishlist-btn, .wishlist-icon, .productView-wishlist a').forEach(function(btn) {
            var handle = btn.getAttribute('data-wishlist-handle');
            if (!handle) {
                var card = btn.closest('.product-item, .pcard, .ctp-card, .best-seller-card, .card, .productView');
                if (card) {
                    var link = card.querySelector('a[href*="/products/"]');
                    if (link) {
                        var href = link.getAttribute('href');
                        var parts = href.split('/products/');
                        if (parts[1]) handle = parts[1].split('?')[0].replace(/\/$/, '');
                    }
                }
            }

            if (handle) {
                var emptySvg = btn.querySelector('.icon-wishlist-empty');
                var filledSvg = btn.querySelector('.icon-wishlist-filled');

                if (items.indexOf(handle) !== -1) {
                    btn.classList.add('wishlist-added');
                    if (emptySvg) emptySvg.style.setProperty('display', 'none', 'important');
                    if (filledSvg) filledSvg.style.setProperty('display', 'block', 'important');
                } else {
                    btn.classList.remove('wishlist-added');
                    if (emptySvg) emptySvg.style.setProperty('display', 'block', 'important');
                    if (filledSvg) filledSvg.style.setProperty('display', 'none', 'important');
                }
            }
        });
    }

    function positionWishlistToast() {
        var toast = document.getElementById('miki-wishlist-popup');
        var navIcon = document.querySelector('.miki-actions .miki-wishlist-icon, .header__icon--wishlist, [data-wishlist-header-icon]');
        if (!toast) return;

        if (navIcon && window.innerWidth > 768) {
            var iconRect = navIcon.getBoundingClientRect();
            var iconCenter = iconRect.left + (iconRect.width / 2);
            var toastWidth = 390;
            var margin = 16;

            // Align toast so the arrow lands precisely beneath the icon center
            var desiredLeft = iconCenter - (toastWidth - 65);
            // Clamp within viewport
            var toastLeft = Math.max(margin, Math.min(desiredLeft, window.innerWidth - toastWidth - margin));
            
            // Calculate arrow coordinate relative to toast left edge
            var arrowLeft = iconCenter - toastLeft - 7;
            arrowLeft = Math.max(20, Math.min(arrowLeft, toastWidth - 30));

            toast.style.setProperty('left', toastLeft + 'px', 'important');
            toast.style.setProperty('right', 'auto', 'important');
            toast.style.setProperty('top', Math.max(70, iconRect.bottom + 8) + 'px', 'important');
            toast.style.setProperty('--arrow-left', arrowLeft + 'px');
            toast.style.setProperty('--arrow-right', 'auto');
        } else if (navIcon) {
            var iconRect = navIcon.getBoundingClientRect();
            var iconCenter = iconRect.left + (iconRect.width / 2);
            var arrowLeft = Math.max(20, Math.min(iconCenter - 12 - 7, window.innerWidth - 45));

            toast.style.setProperty('left', '12px', 'important');
            toast.style.setProperty('right', '12px', 'important');
            toast.style.setProperty('top', (iconRect.bottom + 8) + 'px', 'important');
            toast.style.setProperty('--arrow-left', arrowLeft + 'px');
            toast.style.setProperty('--arrow-right', 'auto');
        }
    }

    function showWishlistToast(productData, isAdded) {
        var popup = document.getElementById('miki-wishlist-popup');
        if (!popup) return;

        // Populate Image
        var imgLink = popup.querySelector('.product-image');
        var imgEl = popup.querySelector('.product-image img');
        if (imgLink) imgLink.setAttribute('href', productData.url || '/pages/wishlist');
        if (imgEl) {
            if (productData.image) {
                imgEl.setAttribute('src', productData.image);
                imgEl.setAttribute('alt', productData.title || 'Wishlist item');
                imgEl.style.display = 'block';
            } else {
                imgEl.style.display = 'none';
            }
        }

        // Populate Title
        var titleEl = popup.querySelector('.product-title .title');
        if (titleEl) {
            titleEl.textContent = productData.title || 'Product';
            titleEl.setAttribute('href', productData.url || '/pages/wishlist');
        }

        // Populate Message & Heart Icon
        var msgEl = popup.querySelector('.wishlist-toast-msg');
        var iconEl = popup.querySelector('.wishlist-toast-icon');
        var badgeEl = popup.querySelector('.success-badge');
        if (msgEl) {
            msgEl.textContent = isAdded ? 'Added to your Wishlist!' : 'Removed from Wishlist';
        }
        if (badgeEl) {
            badgeEl.style.color = isAdded ? '#e53935' : '#71717a';
        }
        if (iconEl) {
            if (isAdded) {
                iconEl.setAttribute('fill', '#e53935');
                iconEl.setAttribute('stroke', '#e53935');
            } else {
                iconEl.setAttribute('fill', 'none');
                iconEl.setAttribute('stroke', '#71717a');
            }
        }

        // Close Cart popup if open to prevent overlap
        document.body.classList.remove('add-to-cart-show');

        // Position arrow directly under nav icon
        positionWishlistToast();

        // Show Toast
        document.body.classList.add('wishlist-show');

        // Auto hide after 4 seconds
        if (wishlistToastTimer) clearTimeout(wishlistToastTimer);
        wishlistToastTimer = setTimeout(function() {
            document.body.classList.remove('wishlist-show');
        }, 4000);
    }

    function closeWishlistToast() {
        if (wishlistToastTimer) clearTimeout(wishlistToastTimer);
        document.body.classList.remove('wishlist-show');
    }

    // Wishlist Button Click Handler
    function handleWishlistClick(e) {
        // Handle Close button inside popup
        if (e.target.closest('[data-close-wishlist-popup]')) {
            e.preventDefault();
            closeWishlistToast();
            return;
        }

        // Handle Wishlist button clicks
        var btn = e.target.closest('[data-wishlist], .miki-card-wishlist-btn, .wishlist-icon, .miki-card-wishlist, .productView-wishlist a');
        if (!btn) {
            // If click outside toast, close toast
            if (document.body.classList.contains('wishlist-show') && !e.target.closest('#miki-wishlist-popup')) {
                closeWishlistToast();
            }
            return;
        }

        // Do not intercept if it's the header navigation wishlist icon link
        if (btn.classList.contains('header__icon--wishlist') || btn.classList.contains('miki-wishlist-icon') || btn.closest('.miki-wishlist-icon')) {
            return;
        }

        // If clicking wrapper .miki-card-wishlist, find button inside
        if (btn.classList.contains('miki-card-wishlist') && !btn.hasAttribute('data-wishlist')) {
            var innerBtn = btn.querySelector('.miki-card-wishlist-btn, [data-wishlist]');
            if (innerBtn) btn = innerBtn;
        }

        e.preventDefault();
        e.stopPropagation();

        var handle = btn.getAttribute('data-wishlist-handle');
        var card = btn.closest('.product-item, .pcard, .ctp-card, .best-seller-card, .card, .productView');

        // Extract title, image, and url
        var title = '';
        var image = '';
        var url = '';

        if (card) {
            var titleEl = card.querySelector('.ctp-title, .best-seller-product-title a, .best-seller-product-title, .card__heading a, .card__heading, .pcard h3, .card-information__text a, .productView-title, h1.productView-title, .card-title, h3 a, h3');
            if (titleEl) {
                var foundText = titleEl.textContent.trim();
                if (foundText && !/add to wishlist/i.test(foundText)) {
                    title = foundText;
                }
            }

            var imgEl = card.querySelector('.ctp-image-wrap img, .productView-image img, .card-media img, .product-item img, img');
            if (imgEl) image = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || imgEl.getAttribute('srcset') || '';
            if (image && image.includes(' ')) {
                image = image.split(' ')[0];
            }

            var linkEl = card.querySelector('a.ctp-title, a.card-title, a[href*="/products/"]');
            if (linkEl) url = linkEl.getAttribute('href') || '';
            if (!handle && url) {
                var parts = url.split('/products/');
                if (parts[1]) handle = parts[1].split('?')[0].replace(/\/$/, '');
            }
        }

        if (!title) {
            var pageTitle = document.querySelector('.productView-title, h1.productView-title');
            if (pageTitle) title = pageTitle.textContent.trim();
        }
        if (!image) {
            var pageImg = document.querySelector('.productView-image img, .productView-thumbnail img');
            if (pageImg) image = pageImg.getAttribute('src') || pageImg.getAttribute('data-src') || '';
        }
        if (!url) {
            if (handle) url = '/products/' + handle;
            else url = window.location.pathname;
        }

        if (!title || /add to wishlist/i.test(title)) title = 'Product';
        if (!handle) {
            var pathParts = window.location.pathname.split('/products/');
            if (pathParts[1]) handle = pathParts[1].split('?')[0].replace(/\/$/, '');
            else handle = btn.getAttribute('data-product-id') || 'product-' + Date.now();
        }

        // Toggle in localStorage
        var items = getWishlistItems();
        var idx = items.indexOf(handle);
        var isAdded = false;

        if (idx === -1) {
            items.push(handle);
            isAdded = true;
        } else {
            items.splice(idx, 1);
            isAdded = false;
        }

        saveWishlistItems(items);
        syncWishlistUI();

        // Dispatch custom events for theme interoperability
        try {
            document.dispatchEvent(new CustomEvent('addwishlistitem', { detail: { handle: handle, isAdded: isAdded } }));
        } catch(err) {}

        // Show Toast Popup
        showWishlistToast({ title: title, image: image, url: url }, isAdded);
    }

    /* =========================================================================
       Miki Cart Clear All Functionality
       ========================================================================= */
    function clearAllCartItems(btn) {
        if (btn) {
            btn.classList.add('is-loading');
            btn.style.opacity = '0.6';
        }

        var rootUrl = (window.routes && window.routes.root) ? window.routes.root.replace(/\/$/, '') : '';

        fetch(rootUrl + '/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
            // Update all badge counts and item text
            document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = '0'; });
            document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(function(el) { el.textContent = '0'; });
            document.querySelectorAll('[data-cart-text]').forEach(function(el) {
                el.textContent = window.cartStrings ? window.cartStrings.items : 'items';
            });

            // Hide all clear all buttons
            document.querySelectorAll('[data-cart-clear-all]').forEach(function(el) {
                el.classList.add('is-hidden');
                el.style.display = 'none';
            });

            // Update Theme Sidebar Cart if available
            if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
                window.halo.updateSidebarCart(cart);
            } else if (window.jQuery) {
                $.ajax({
                    type: 'GET',
                    url: rootUrl + '/cart?section_id=ajax-side-cart',
                    cache: false,
                    success: function(data) {
                        var response = $(data);
                        var htmlToInsert = response.hasClass('shopify-section') ? response.html() : response;
                        $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper').html(htmlToInsert);
                    }
                });
            }

            // If on main cart page, reload to show empty cart state
            if (window.location.pathname.indexOf('/cart') !== -1 && !document.body.classList.contains('cart-sidebar-show')) {
                window.location.reload();
            }

            try {
                document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
            } catch (e) {}
        })
        .catch(function(err) {
            console.error('Error clearing cart:', err);
        })
        .finally(function() {
            if (btn) {
                btn.classList.remove('is-loading');
                btn.style.opacity = '1';
            }
        });
    }

    // Attach Wishlist and Cart Clear Click Handlers (using capture phase for immediate interception)
    document.addEventListener('click', handleWishlistClick, true);

    document.addEventListener('click', function(e) {
        var clearBtn = e.target.closest('[data-cart-clear-all]');
        if (!clearBtn) return;

        e.preventDefault();
        e.stopPropagation();

        clearAllCartItems(clearBtn);
    });

    // Listen for cart-update to show/hide Clear All buttons
    document.addEventListener('cart-update', function(e) {
        var cart = e.detail;
        if (!cart) return;
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-clear-all]').forEach(function(btn) {
            if (count > 0) {
                btn.classList.remove('is-hidden');
                btn.style.display = '';
            } else {
                btn.classList.add('is-hidden');
                btn.style.display = 'none';
            }
        });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncWishlistUI);
    } else {
        syncWishlistUI();
    }
    window.addEventListener('storage', syncWishlistUI);
    window.addEventListener('resize', positionWishlistToast);
    document.addEventListener('addwishlistitem', syncWishlistUI);
})();

